import ShareableLinksEmpty from './ShareableLinksEmpty.component';

export default ShareableLinksEmpty;